declare const jQuery: any;
const $ = jQuery;
const defaultActionName: string = "load_more_posts";
import { fetchPosts, getScrollToOffset } from "./load-more";

interface FetchResponse
{
	more: boolean;
	html: any[];
}

export function initPostsPagination(): void
{
	const $wrapWraps = $(".posts-pagination");
	if ($wrapWraps.length === 0)
	{
		return;
	}
	$wrapWraps.each(function () {
		const $wrapWrap = $(this);
		const $btns = $wrapWrap.find(`[data-offset]`);
		if ($btns.length === 0)
		{
			return;
		}
		const $itemsWrap = $(".post-items-wrap > div,[data-post-items]").first();
		if ($itemsWrap.length === 0)
		{
			console.error("Failed to find posts container for pagination");
			return;
		}
		const $prevBtn = $wrapWrap.find(".pag-prev");
		const $nextBtn = $wrapWrap.find(".pag-next");
		const termId: number = parseInt($wrapWrap.attr("data-term"), 10) || 0;
		const authorId: number = parseInt($wrapWrap.attr("data-author"), 10) || 0;
		const search: string = $wrapWrap.attr("data-search") || "";
		const actionName: string = $wrapWrap.attr("data-action") || defaultActionName;
		const postType: string = $wrapWrap.attr("data-post-type") || undefined;
		const doEllipses: boolean = $btns.length > 4 && $wrapWrap.is(`[data-ellipses]`);
		if (!doEllipses)
		{
			$btns.addClass("show");
		}
		const removePaginationEllipses = () => doEllipses && $wrapWrap.find(".ellipsis").remove();
		const lastPaginationIndex: number = $btns.length - 1;
		const ellipsisSymbol = $wrapWrap.attr("data-ellipsis-symbol") || "&hellip;";
		const ellipsisHtml = `<li class="ellipsis">${ellipsisSymbol}</li>`;
		const updatePagination = function updatePagination(currIndex: number): void {
			$prevBtn.css({ display: (currIndex < 1) ? 'none' : '' });
			if (!doEllipses)
			{
				return;
			}
			const $paginationItems = $wrapWrap.find("ul").first().children("li");
			const withinRange = (index: number): boolean => index >= currIndex - 1 && index <= currIndex + 1;
			$paginationItems.removeClass("show");
			let prevWasShown = true;
			let prevWasEllipsis = false;
			$paginationItems.each(function (index: number) {
				const $item = $(this);
				if (index === 0)
				{
					$item.addClass("show");
					return;
				}
				if (index === lastPaginationIndex)
				{
					$item.addClass("show");
					if (!prevWasShown && !prevWasEllipsis)
					{
						$item.before(ellipsisHtml);
					}
					return;
				}
				if (!withinRange(index))
				{
					if (prevWasShown)
					{
						if (!prevWasEllipsis)
						{
							$item.after(ellipsisHtml);
							prevWasEllipsis = true;
						}
						else
						{
							prevWasEllipsis = false;
						}
						prevWasShown = false;
					}
					return;
				}
				$item.addClass("show");
				if (!prevWasShown)
				{
					if (!prevWasEllipsis)
					{
						$item.after(ellipsisHtml);
						prevWasEllipsis = true;
					}
					else
					{
						prevWasEllipsis = false;
					}
					prevWasShown = true;
				}
				else
				{
					prevWasEllipsis = false;
				}
			});
		};
		updatePagination(0);
		let fetching: boolean = false;
		const handleError = function handleError(...errMsgs) {
			console.error("ERROR:", ...errMsgs);
		};
		const onComplete = function onComplete() {
			fetching = false;
			$wrapWrap.removeClass("busy");
			$itemsWrap.removeClass("busy");
		};
		const onFetchSuccess = function onFetchSuccess(res: FetchResponse): void {
			const $items = $(res.html).filter(function () {
				return $(this).is(`[data-post-item]`);
			}).css("opacity", 0);
			$itemsWrap.empty().append($items);
			$.scrollTo($itemsWrap, 350, {
				axis: "y",
				offset: { top: getScrollToOffset() }
			});
			$items.each(function (index) {
				const $item = $(this);
				setTimeout(() => {
					$item.css("opacity", 1);
				}, 300 * index + 50);
			});
			$nextBtn.css({ display: res.more ? '' : 'none' });
			$(document).trigger("post-items-inserted", {
				$items,
				$itemsWrap,
				fetchResponse: res
			});
		};
		$btns.click(function (ev): false {
			if (fetching)
			{
				return false;
			}
			const $btn = $(this);
			if ($btn.hasClass("current"))
			{
				return false;
			}
			fetching = true;
			$wrapWrap.addClass("busy");
			$itemsWrap.addClass("busy");
			const offset: number = parseInt($btn.attr("data-offset"), 10);
			fetchPosts(actionName, { offset, termId, search, authorId, postType }, function then(res: any) {
				onComplete();
				if (!res)
				{
					handleError("No server response", res);
					return;
				}
				if (res.html === undefined)
				{
					handleError("HTML missing in server response",res);
					return;
				}
				removePaginationEllipses();
				$btns.removeClass("current");
				$btn.addClass("current");
				updatePagination($btn.index());
				onFetchSuccess(res);
			}, onComplete);
			return false;
		});

		const length: number = (parseInt($btns.eq(1).attr("data-offset"), 10)) || 10;

		$prevBtn.add($nextBtn).click(function(e){
			if (fetching)
			{
				return false;
			}
			const $btn = $btns.filter(".current");
			const isPrev: boolean = $(this).is(".pag-prev");
			const offset: number = parseInt($btn.attr("data-offset"), 10) + (isPrev ? -length : length);
			if (offset < 0)
			{
				console.error("offset < 0", offset);
				return false;
			}
			fetching = true;
			$wrapWrap.addClass("busy");
			$itemsWrap.addClass("busy");
			fetchPosts(actionName, { offset, termId, search, authorId, postType }, function then(res: any) {
				onComplete();
				if (!res)
				{
					handleError("No server response", res);
					return;
				}
				if (res.html === undefined)
				{
					handleError("HTML missing in server response",res);
					return;
				}
				removePaginationEllipses();
				$btns.removeClass("current");
				const $newBtn = isPrev ? $btn.prev() : $btn.next();
				$newBtn.addClass("current");
				updatePagination($newBtn.index());
				onFetchSuccess(res);
			}, onComplete);
			return false;
		});

	});
}
